import { useEffect } from "react";

// Sidebar links dispatch "yoko:refresh-route" when the user clicks the nav item for the
// page they are already on (instead of navigating away to Dashboard). Any page that wants
// its "click current link again" behavior to actually refetch data opts in with this hook.
export function useRouteRefresh(callback) {
  useEffect(() => {
    const handler = () => callback();
    window.addEventListener("yoko:refresh-route", handler);
    return () => window.removeEventListener("yoko:refresh-route", handler);
  }, [callback]);
}
